<template>
  <v-layout align-center class="pointer" py-1>
    <v-layout align-center @click="() => !isInEditView && clicked()" style="width: 185px;">
      <div class="my-groups-selection" :class="{'flex w-full' : isInEditView}" style="overflow: hidden">
        <v-icon v-if="isSelected" color="primary" class="mr-1">mdi-check</v-icon>
        <v-icon v-else class="mr-1">mdi-blank</v-icon>
        <div class="my-groups-text-row" :class="{'bigger': isInEditView}">
          <template v-for="(subRow, i) in row.rows" v-if="!isInEditView">
            <div class="my-groups-name" :key="`flist-${row.id}-${i}`">
              {{subRow}}
            </div>
            <span class="my-groups-results">{{ $t('watchlist_results', {count: row.studentCount}, row.studentCount) }}</span>
          </template>
          <template v-else>
            <div :class="{flat: isInEditView}">
              <MyGroupUpdate :groups="groups"
                             :selectedItem="getGroupById(row.id)"
                             :closeEditForm="() => isInEditView = false"
                             :stop-propagation="true"
                             @edit-form:close="isInEditView = false"
              />
            </div>
          </template>
        </div>
      </div>
    </v-layout>
    <template v-if="!isInEditView">
      <MyGroupDelete :group="row" @deleted="deleted"/>
      <v-btn @click="() => isInEditView = true" icon>
        <v-icon size="20px">stream-edit</v-icon>
      </v-btn>
    </template>
  </v-layout>
</template>

<script>
  import MyGroupDelete from '../student/group/MyGroupDelete'
  import { mapActions, mapMutations, mapState } from 'vuex'
  import { SET_SELECTED_GROUP, SWITCH_TABLE_MODE } from '../../store/mutation-types'
  import { CLEAR_MY_FILTER } from '../../store/action-types'
  import MyGroupUpdate from '../student/group/MyGroupUpdate.vue'

  export default {
    name: 'MyGroupsFilterListRow',
    components: { MyGroupUpdate, MyGroupDelete },
    props: {
      row: {
        type: Object,
        required: true
      },
      idSet: {
        type: Set,
        required: true
      },
      selectedButtonText: {
        type: Function,
        required: true
      },
      showDeleteOption: {
        type: Boolean,
        required: true
      },
      selectedItem: {
        type: Number,
        required: true
      }
    },
    destroyed () {
      this.isInEditView = false
    },
    data () {
      return {
        isInEditView: false
      }
    },
    computed: {
      ...mapState({
        groups: state => state.groups.groups,
        selectedDefaultFilter: state => state.students.selectedDefaultFilter
      }),
      isSelected () {
        return this.idSet.has(this.row.id)
      }
    },
    methods: {
      ...mapActions({
        clearMyFilter: CLEAR_MY_FILTER
      }),
      ...mapMutations({
        setSelectedGroup: SET_SELECTED_GROUP,
        setTableMode: SWITCH_TABLE_MODE
      }),
      getGroupById (id) {
        return this.groups.find(x => x.id === id)
      },
      clicked () {
        this.selectedButtonText(this.row.rows.toString())
        this.$emit('selected', {id: this.row.id, selected: !this.isSelected})
        this.setSelectedGroup({
          id: this.row.id,
          name: this.row.rows[0],
          results: this.row.studentCount
        })
        /* if (Object.keys(this.selectedDefaultFilter).length > 0 && this.selectedDefaultFilter.id) {
          this.clearMyFilter({
            description: this.selectedDefaultFilter.description,
            defaultSearch: false,
            id: this.selectedDefaultFilter.id
          })
        } */
        this.setTableMode('MYSTUDENTS')
      },
      deleted (id) {
        this.$emit('dgroup', id)
      }
    }
  }
</script>

<style scoped>
  .my-groups-text-row {
    padding-left: 20px;
  }

  .my-groups-selection {
    display: flex;
    align-items: center;
  }

  .my-groups-name {
    font-size: 14px;
    font-weight: 500;
  }

  .my-groups-results {
    opacity: 0.7;
  }
  .flex {
    display: flex;
  }
  .w-full {
    width: 100%;
  }
  .flat /deep/ .my-groups-update {
    padding: 0 !important;
    padding-right: 26px !important;
    width: 100%;
    display: flex;
  }
  .my-groups-text-row.bigger {
    padding: 0 !important;
    display: flex !important;
    width: 100% !important;
  }
  .flat {
    width: 100%;
  }
  .flat /deep/ .my-groups-form {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/filter/MyGroupsFilterListRow.vue